import type { ServiceLandingPathDescriptor } from '@rover/shared/js/hooks/useServiceLanding';
import { RoverBrand } from '@rover/types/src/RoverBrand';

import parseCatInAFlatServiceLandingPath from './parseCatInAFlatServiceLandingPath';
import parseRoverServiceLandingPath from './parseRoverServiceLandingPath';

export interface ServiceLandingParseContext {
  hostname: string;
  language?: string | null;
  countryCode?: string | null;
}

type ServiceLandingPathParser = (
  path: string,
  context: ServiceLandingParseContext
) => ServiceLandingPathDescriptor;

const parseRover: ServiceLandingPathParser = (path) => parseRoverServiceLandingPath(path);

const PARSERS: Record<RoverBrand, ServiceLandingPathParser> = {
  [RoverBrand.Rover]: parseRover,
  [RoverBrand.DogBuddy]: parseRover,
  [RoverBrand.MadPaws]: parseRover,
  [RoverBrand.CatInAFlat]: (path, { hostname, language, countryCode }) =>
    parseCatInAFlatServiceLandingPath(path, hostname, language, countryCode),
};

const parseServiceLandingPath = (
  path: string,
  brand: RoverBrand,
  context: ServiceLandingParseContext
): ServiceLandingPathDescriptor => (PARSERS[brand] ?? parseRover)(path, context);

export default parseServiceLandingPath;
